import { render, staticRenderFns } from "./FloorFigure.vue?vue&type=template&id=389c2c5d&"
import script from "./FloorFigure.vue?vue&type=script&lang=js&"
export * from "./FloorFigure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports